export default __webpack_public_path__ + "static/media/OutlineIcon.cdb135e0.svg";